/**
 * asfaBudget.ts – ASFA Comfortable Standard budget figures (hypothetical for demonstration).
 * March Quarter 2025. Ported verbatim from frontend/src/constants/asfaBudget.js.
 */
export const ASFA_BUDGET = {
    couple: {
        total: 72148,
        categories: {
            'Housing': 7800,
            'Energy': 2500,
            'Food & Groceries': 15000,
            'Clothing & Footwear': 3000,
            'Household Goods & Services': 5000,
            'Health': 8000,
            'Transport': 8500,
            'Communication': 2000,
            'Recreation': 15348,
            'Miscellaneous': 5000,
        },
    },
    single: {
        total: 51278,
        categories: {
            'Housing': 6500,
            'Energy': 1800,
            'Food & Groceries': 8000,
            'Clothing & Footwear': 2500,
            'Household Goods & Services': 4000,
            'Health': 6000,
            'Transport': 6500,
            'Communication': 1500,
            'Recreation': 10478,
            'Miscellaneous': 3000,
        },
    },
};
